import styles from './index.module.sass';
import InfoSvg from '@@/buyer-account/images/info.svg';

export const WarningVerification = () => {
    return (
        <div className={styles.root}>
            <img src={InfoSvg} alt="warning"/>
            <span>Ваша учетная запись отправлена для проверки нашему менеджеру, после успешной авторизации заявки, вы сможете принимать участие в сделках</span>
        </div>
    )
}